export const lightTheme = {
  rowColor: 'hsl(0, 0%, 98%)',
  background: 'hsl(236, 33%, 92%)',
  completedText: 'hsl(233, 11%, 70%)',
  text: 'hsl(236, 9%, 40%)',
  textHover: ' hsl(236, 15%, 60%)',
  borderColor: 'hsla(235, 21%, 11%, 0.1)',
};

export const darkTheme = {
  background: 'hsl(235, 21%, 11%)',
  rowColor: 'hsl(235, 24%, 19%)',
  completedText: 'hsl(233, 14%, 35%)',
  text: 'hsl(234, 39%, 85%)',
  textHover: 'hsl(236, 10%, 50%)',
  borderColor: 'hsla(235, 39%, 85%, 0.1)',
};
